module.exports = __webpack_public_path__ + "img/left.83a6db62.svg";